<template>
  <b-card class="shadow text-center">
    <b-link
      @click.prevent="redirect()"
      href="#"
      class="card-link"
      v-if="condicao"
    >
      <span style="font-size: 48px">
        <i :class="icone"></i>
      </span>
      <br />
      {{ titulo }}
      <small class="text-muted d-block mt-1" v-if="counts != 'none'">
        <i class="fas fa-chart-bar"></i>
        <span v-if="counts">
          {{ counts | maskNumber }}
        </span>
        <span v-else>0</span>
      </small>
    </b-link>
    <b-link href="#" class="card-link disabled" title="Sem permissão" v-else>
      <span style="font-size: 48px">
        <i :class="icone"></i>
      </span>
      <br />
      {{ titulo }}
      <small class="text-muted d-block mt-1" v-if="counts != 'none'">
        <i class="fas fa-chart-bar"></i>
        <span v-if="counts">
          {{ counts | maskNumber }}
        </span>
        <span v-else>0</span>
      </small>
    </b-link>
  </b-card>
</template>

<script>
export default {
  props: ["rota", "titulo", "counts", "condicao", "icone"],
  methods: {
    redirect() {
      this.$router.push(this.rota);
    },
  },
};
</script>

<style>
</style>
